const SetupUsersLeadDayValuesActionTypes = {
  GET_LEAD_DAY_VALUES_START: 'GET_LEAD_DAY_VALUES_START',
  GET_LEAD_DAY_VALUES_SUCCESS: 'GET_LEAD_DAY_VALUES_SUCCESS',
  GET_LEAD_DAY_VALUES_FAILURE: 'GET_LEAD_DAY_VALUES_FAILURE',
};

export default SetupUsersLeadDayValuesActionTypes;
